import * as Yup from 'yup'

export const AddressSchema = Yup.object({
    address:Yup.object(),
    remark:Yup.string()
})